import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { PackFragment } from '../../queries';
import { useFormContext } from 'react-hook-form';
import { TextField } from '@material-ui/core';
import { PackFormData } from '../../pages/PackAdd';

const useStyles = makeStyles({
  label: {
    color: '#fff',
    fontWeight: 600,
  },
});

interface Props {
  isEdit?: boolean;
  pack?: PackFragment;
}

export default function PackDetails({ pack, isEdit }: Props) {
  const classes = useStyles();
  const { register } = useFormContext<PackFormData>();

  return (
    <Box p={5}>
      <Grid container spacing={3}>
        {!isEdit && (
          <>
            <Grid item lg={6} xs={12}>
              <Typography className={classes.label}>Pack name</Typography>
              <Typography>{pack?.name ?? '-'}</Typography>
            </Grid>
            <Grid item lg={6} xs={12}>
              <Typography className={classes.label}>Code</Typography>
              <Typography>{pack?.code ?? '-'}</Typography>
            </Grid>
          </>
        )}

        {isEdit && (
          <>
            <Grid item lg={6} xs={12}>
              <TextField
                name="name"
                label="Pack name"
                variant="outlined"
                fullWidth
                inputRef={register}
                inputProps={{ maxLength: 255 }}
                required
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <TextField
                name="code"
                label="Pack code"
                variant="outlined"
                fullWidth
                inputRef={register}
                inputProps={{ maxLength: 255 }}
                required
              />
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
}
